<template>
  <div v-if="quoteDistribution.id">
    <quote-distribution-component :quote-distribution="quoteDistribution" />
  </div>
</template>

<script>
import { onUnmounted } from '@vue/composition-api'
import store from '@/store'
import quoteDistributionModule from '@/store/quote-distribution'
import quoteDistributionComponent from '@/views/components/QuoteDistributionComponent.vue'

export default {
  components: {
    quoteDistributionComponent,
  },
  computed: {
    quoteDistribution() {
      return this.$store.state[this.MODULE_NAME].quoteDistribution
    },
  },
  created() {
    this.refetchData()
  },
  methods: {
    refetchData() {
      this.$store.commit(`${this.MODULE_NAME}/FRESH`)
      this.$store.dispatch(`${this.MODULE_NAME}/get`, this.$route.params.id)
    },
  },
  setup() {
    const MODULE_NAME = 'quoteDistribution'
    // Register module
    if (!store.hasModule(MODULE_NAME)) store.registerModule(MODULE_NAME, quoteDistributionModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(MODULE_NAME)) store.unregisterModule(MODULE_NAME)
    })
    return {
      MODULE_NAME,
    }
  },
}
</script>
